import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import logger from '@sravni/server-utils/lib/logger';

import { SurveyWidget } from '../../components/SurveyWidget';
import { useFingerprint } from '../../hooks/users';
import { getQuizForUser } from '../../services/quiz';

export const Survey = () => {
  const {
    query: { surveyId },
  } = useRouter();

  const fingerPrint = useFingerprint();
  const [surveyInfo, setSurveyInfo] = useState(null);

  useEffect(() => {
    const getQuiz = async () => {
      try {
        const data = await getQuizForUser({ voteId: surveyId as string, fingerPrint });
        setSurveyInfo(data);
      } catch (error) {
        logger.log({
          level: 'error',
          message: 'Failed to load quiz for user',
          exception: {
            message: error.message,
            stack: error.stack,
          },
        });
      }
    };

    getQuiz();
  }, [fingerPrint, surveyId]);

  if (!surveyInfo) return null;

  return <SurveyWidget surveyInfo={surveyInfo} />;
};

Survey.getInitialProps = () => {
  return {};
};

export default Survey;
